// @flow
import { createLogger as createClientLogger } from './clientLogger';
import { createLogger as createServerLogger } from './serverLogger';

export const createLogger = ({ server, client }: { client: boolean, server: boolean }) => {
    return global.__SERVER__ ? createServerLogger(server) : createClientLogger(client);
};
